import {Component, ContentChildren, Input, QueryList} from "@angular/core";
import {FUINameValueListEntryComponent} from "./name-value-list-entry/name-value-list-entry.component";

@Component({
    selector: "fui-name-value-list",
    styleUrls: ["./name-value-list.component.scss"],
    templateUrl: "./name-value-list.component.html",
    standalone: false
})
export class FUINameValueListComponent {
    @ContentChildren(FUINameValueListEntryComponent) entries: QueryList<FUINameValueListEntryComponent>;
    @Input() public emptyDescription: string;
    @Input() public emptyTitle: string;
}
